<template>
  <div class="modal fade" id="modalChangeRetroactiveShift" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="title-modal">{{ pgTitle }}</h4>
        </div>

        <div class="modal-body">
          <form>
            <div class="form-group">
              <label>Funcionário ID</label>
              <input v-model="dataChange.employeeId" type="text" class="form-control" name="employeeId" readonly>
            </div>

            <div v-if="isChange" class="form-group">
              <label>Turno de trabalho ID</label>
              <input v-model="dataChange.workShiftId" type="text" class="form-control" name="workShiftId" readonly>
            </div>

            <div class="form-group">
              <label>Data de admissão</label>
              <input v-model="viewAdmissionDate" type="text" class="form-control" name="viewAdmissionDate" readonly>
            </div>

            <div class="form-group select-date">
              <label>Data Inicial</label>
              <datepicker v-model="dateInit" :language="ptBR" :format="customFormatter" placeholder="dd/mm/yyyy"/>
              <i class="fa fa-calendar" aria-hidden="true"></i>
              <span v-if="errorMsg.dataInit" class="error-msg">{{ errorMsg.dataInit }}</span>
            </div>

            <div class="form-group select-date">
              <label>Primeiro dia Seguinte do Cíclico</label>
              <datepicker v-model="firstDayNextCiclic" :language="ptBR" :format="customFormatter"
                          placeholder="dd/mm/yyyy"/>
              <i class="fa fa-calendar" aria-hidden="true"></i>
              <span v-if="errorMsg.firstDayCyclic" class="error-msg">{{ errorMsg.firstDayCyclic }}</span>
            </div>

            <div class="form-group">
              <label>Utilizar a Data de Admissão?</label>
              <div class="checkbox inline-block">
                <input v-model="dataChange.admissionDate" id="admissionDate" type="checkbox">
                <label></label>
              </div>
            </div>

            <div class="form-group">
              <label>Retroativo?</label>
              <div class="checkbox inline-block">
                <input v-model="dataChange.isRetroactive" id="isRetroactiveFalse" type="checkbox">
                <label></label>
              </div>
            </div>

          </form>
        </div>

        <div class="modal-footer">
          <button v-on:click="changeWs()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}"
                  type="submit" class="btn btn-register">
            <span v-if="!loadingChange">Salvar</span>
            <div class="loading-btn" v-else>
              <div class="spinner-btn">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </button>
          <button v-on:click="closeModal()" class="close-btn">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  UPDATE_WS_R
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";

import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import moment from 'moment'

export default {
  name: "modalChangeRetroactiveShift",
  props: ['dataModal', 'changeOrUpdate'],
  components: {
    datepicker
  },
  data() {
    return {
      ptBR: ptBR,
      pgTitle: '',
      isChange: false,
      viewAdmissionDate: '',
      errorMsg: {
        dataInit: '',
        firstDayCyclic: ''
      },
      dateInit: '',
      firstDayNextCiclic: '',
      dataChange: {
        workShiftId: '',
        employeeId: '',
        isRetroactive: '',
        admissionDate: '',
        dateInit: '',
        firstDayNextCiclic: ''
      },
      reloadUserInfo: null,
      loadingChange: false
    }
  },
  watch: {
    changeOrUpdate: function (val) {
      if (val === 1) {
        this.pgTitle = 'Trocar Turno Retroativo';
        this.isChange = true;
      } else {
        this.pgTitle = 'Atualizar Turno Retroativo';
        this.isChange = false;
      }
    },
    dataModal: function (val) {
      this.dataChange.employeeId = val.id;
      this.dataChange.workShiftId = val.workShiftId;
      this.dataChange.admissionDate = false;
      this.dataChange.isRetroactive = false;
      this.dataChange.dateInit = '';
      this.dataChange.firstDayNextCiclic = '';

      this.viewAdmissionDate = moment(val.admissionDate).format('DD/MM/YYYY');

    },
    reloadUserInfo: function (val) {
      this.$emit('update:reloadUserInfo', val)
    },
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    closeModal() {
      $('#modalChangeRetroactiveShift').modal('toggle');
    },
    changeWs() {
      this.errorMsg.dataInit = '';
      this.errorMsg.firstDayCyclic = '';

      if (!this.dataChange.admissionDate && !this.dateInit) {
        this.errorMsg.dataInit = "Por favor preencha a data inicial.";

        if (!this.firstDayNextCiclic)
          this.errorMsg.firstDayCyclic = "Por favor preencha o primeiro dia seguinte do cíclico.";

        return;
      }

      if (this.firstDayNextCiclic) {
        if (!this.isChange)
          this.dataChange.workShiftId = '';

        if (this.dateInit)
          this.dataChange.dateInit = moment(this.dateInit).format("YYYY-MM-DD");

        this.dataChange.firstDayNextCiclic = moment(this.firstDayNextCiclic).format("YYYY-MM-DD");

        UTIL_SERVICE.console("DATA SEND:", this.dataChange);
        REQUEST_SERVICE.put(UPDATE_WS_R, this.dataChange).then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_USER_WS:", response);
          this.reloadUserInfo = Math.floor(Math.random() * 100);

          $('#modalChangeRetroactiveShift').modal('toggle');

          ALERT_SERVICE.swal("Aviso", "Turno atualizado com sucesso.", "success");
        }).catch((reason) => {
          $('#modalChangeRetroactiveShift').modal('toggle');

          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      } else {
        this.errorMsg.firstDayCyclic = "Por favor preencha o primeiro dia seguinte do cíclico.";
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#modalChangeRetroactiveShift {
  .select-date {
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .inline-block {
    display: inline-block;
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeRetroactiveShift.vue